import queryString from 'query-string'
import history from '../history'

export default {
    set: function (params) {
        // if setting qs to nothing push the pathname to history
        if (!Object.keys(params).length) {
            history.push(window.location.pathname)
        } else {
            // set the querystring to the given params
            let newPath = window.location.pathname
            newPath += '?'
            newPath += queryString.stringify(params)
            if (history.location.pathname + history.location.search !== newPath) {
                // only add new paths so back history doesn't get stuck
                history.push(newPath)
            }
        }
    },

    parse: function (str) {
        const qs = queryString.parse(str)
        Object.keys(qs).forEach(key => {
            if (qs[key].toLowerCase === 'true') {
                qs[key] = true
            } else if (qs[key].toLowerCase === 'false') {
                qs[key] = false
            }
        })
        return qs
    }
};
